module.exports = __webpack_public_path__ + "img/hyu_1.a6fc688d.png";